package com.kinoshazam.screens.person.host

import androidx.compose.runtime.Composable
import androidx.compose.runtime.getValue
import androidx.lifecycle.compose.collectAsStateWithLifecycle
import androidx.navigation.NavBackStackEntry
import androidx.navigation.toRoute
import com.kinoshazam.model.Route
import com.kinoshazam.screens.person.compact.CompactPersonContent
import com.kinoshazam.screens.person.expanded.ExpandedPersonWindow
import com.kinoshazam.screens.person.medium.MediumPersonContent
import org.koin.compose.viewmodel.koinViewModel
import presentation.screens.person.PersonViewModel
import utils.FormFactor

@Composable
fun PersonContentHost(
    formFactor: FormFactor,
    backStackEntry: NavBackStackEntry,
) {
    val route = backStackEntry.toRoute<Route.Dialog.Person>()
    val viewModel = koinViewModel<PersonViewModel>(
        viewModelStoreOwner = backStackEntry,
        key = "person_${route.personId}",
    )
    val state by viewModel.state.collectAsStateWithLifecycle()

    when (formFactor) {
        FormFactor.Compact, FormFactor.Medium -> CompactPersonContent(
            state = state,
            onAction = viewModel::onAction,
        )

        FormFactor.Expanded -> MediumPersonContent(
            state = state,
            onAction = viewModel::onAction,
        )

        FormFactor.ExtraLarge -> ExpandedPersonWindow(
            state = state,
            onAction = viewModel::onAction,
        )
    }
}
